import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { WALLPAPER_WATERMARK_MODE } from '../../../constants/pro-settings';
import { useWatermarkImage } from './useWatermarkImage';

const propTypes = {
  text: PropTypes.string,
  fontSize: PropTypes.number,
  imageUrl: PropTypes.string,
  wallpaperMode: PropTypes.string,
};

const WatermarkOverlay = ({
  text = 'waldo',
  fontSize = 50,
  imageUrl,
  wallpaperMode,
}) => {
  const containerRef = useRef(null);
  const isTextMode = wallpaperMode === WALLPAPER_WATERMARK_MODE.TEXT;
  const isImageMode = wallpaperMode === WALLPAPER_WATERMARK_MODE.IMAGE;
  const watermarkClasses = classNames({
    'watermark-overlay-text': isTextMode,
    'watermark-overlay-img': isImageMode && imageUrl,
    'watermark-overlay-img-default': isImageMode && !imageUrl,
  });

  const watermarkImage = useWatermarkImage({
    text,
    fontSize,
    imageUrl,
    wallpaperMode,
    containerRef,
  });

  return (
    <div ref={containerRef} className="watermark-overlay-container">
      {watermarkImage && (
        <div
          className={watermarkClasses}
          style={{
            backgroundImage: `url(${watermarkImage})`,
          }}
        />
      )}
    </div>
  );
};

WatermarkOverlay.propTypes = propTypes;

export default WatermarkOverlay;
